import { Routes, Route, Navigate } from 'react-router-dom'
import { MsalAuthenticationTemplate } from '@azure/msal-react'
import { InteractionType } from '@azure/msal-browser'
import type { AuthError as MsalAuthError } from '@azure/msal-browser'
import { loginRequest } from './authConfig'
import AuthGuard from './components/AuthGuard'
import Layout from './components/Layout/Layout'
import Dashboard from './pages/Dashboard'
import ProjectTracker from './pages/ProjectTracker'
import AdminPanel from './pages/AdminPanel'
import AuditLog from './pages/AuditLog'

function LoginSpinner() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-10 w-10 border-b-2 border-purple-600"></div>
        <p className="mt-4 text-gray-600 font-medium">Signing in to Bridgenext&hellip;</p>
      </div>
    </div>
  )
}

function AuthErrorView({ error }: { error: MsalAuthError | null }) {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-center max-w-md">
        <h1 className="text-2xl font-bold text-red-600">Authentication Error</h1>
        <p className="mt-2 text-gray-600">
          {error?.message || 'Failed to sign in. Please try again.'}
        </p>
        <button
          onClick={() => window.location.reload()}
          className="mt-4 px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700"
        >
          Retry
        </button>
      </div>
    </div>
  )
}

export default function App() {
  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={loginRequest}
      loadingComponent={LoginSpinner}
      errorComponent={AuthErrorView}
    >
      <Layout>
        <Routes>
          <Route
            path="/"
            element={
              <AuthGuard>
                <Dashboard />
              </AuthGuard>
            }
          />
          <Route
            path="/projects/:id"
            element={
              <AuthGuard>
                <ProjectTracker />
              </AuthGuard>
            }
          />
          <Route
            path="/admin"
            element={
              <AuthGuard minRole="Administrator">
                <AdminPanel />
              </AuthGuard>
            }
          />
          <Route
            path="/admin/audit"
            element={
              <AuthGuard minRole="Administrator">
                <AuditLog />
              </AuthGuard>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </MsalAuthenticationTemplate>
  )
}
